import http from "@/utils/request"

export default {
  getSystemBaseInfo: {
    url: 'system/systemCustom/getInfo',
    name: '系统设置',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  systemBaseInfoAdd: {
    url: 'system/systemCustom/add',
    name: '系统设置-新增',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  monitoringfeeInfo: { // 业务配置
    url: 'system/dict/data/new/type',
    name: '监控费用设置',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  monitoringfeeSave: { // 业务配置
    url: 'system/config/batch/edit',
    name: '监控费用设置-编辑',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  depSetPage: { // 部门设置
    url: 'section/list',
    name: '部门设置-分页',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  depSetList: { // 部门设置
    url: 'system/dept/list',
    name: '部门设置-列表',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  depSetSave: { // 部门设置
    url: 'section/edit',
    name: '部门设置-编辑',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  batchEditTermOrNum: { // 部门设置
    url: 'section/batch/edit',
    name: '部门设置-批量修改账号数量/到期期限',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  depSetFullSync: { // 部门设置
    url: 'section/full/synchronization',
    name: '部门设置-全量同步',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  depSetEarlyWarningSync: { // 部门设置
    url: 'section/forewarning/synchronization',
    name: '部门设置-预警同步',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  depSetAbnormalSync: { // 部门设置
    url: 'section/abnormal/synchronization',
    name: '部门设置-异常同步',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  roleStaffList: { // 角色权限管理
    url: 'system/role/authUser/allocatedList',
    name: '角色权限管理-角色员工列表',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  roleList: { // 角色权限管理
    url: 'system/role/tree/list',
    name: '角色权限管理-角色列表',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  roleAdd: { // 角色权限管理
    url: 'system/role/add',
    name: '角色权限管理-新增角色',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  roleEdit: { // 角色权限管理
    url: 'system/role/edit',
    name: '角色权限管理-编辑角色',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  roleDel: { // 角色权限管理
    url: 'system/role/delete',
    name: '角色权限管理-删除角色',
    post: async function(data, config={headers:{'Content-Type': 'application/json;charset=UTF-8'}}) {
      return await http.post(this.url, data, config)
    }
  },
  associationStaff: { // 角色权限管理
    url: 'system/role/authUser/selectAll',
    name: '关联员工',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  staffList: { // 角色权限管理
    url: 'system/user/list',
    name: '关联员工-员工列表',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  cancelAssociation: { // 角色权限管理
    url: 'system/role/authUser/cancel',
    name: '解除关联员工（删除员工）',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  deptListTree: { // 员工与部门管理
    url: 'system/dept/treeselect',
    name: '部门树形列表',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  deptList: { // 员工与部门管理
    url: 'system/dept/list',
    name: '新增编辑-部门列表',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  deptDetail: { // 员工与部门管理
    url: 'system/dept/getInfo',
    name: '部门详情',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  deptAdd: { // 员工与部门管理
    url: 'system/dept/add',
    name: '新增部门',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  deptEdit: { // 员工与部门管理
    url: 'system/dept/edit',
    name: '编辑部门',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  deptDel: { // 员工与部门管理
    url: 'system/dept/delete',
    name: '删除部门',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  deptStaffList: { // 员工与部门管理
    url: 'system/dept/user',
    name: '部门下的员工',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  deptStaffAdd: { // 员工与部门管理
    url: 'system/user/add',
    name: '新增部门下的员工',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  deptStaffEdit: { // 员工与部门管理
    url: 'system/user/edit',
    name: '编辑部门下的员工',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  deptChangeStatus: { // 员工与部门管理
    url: 'system/user/batch/changeStatus',
    name: '禁用激活',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  resetPassword: {
    url: 'system/user/batch/resetPwd',
    name: '批量重置密码',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  resetAccount: {
    url: 'system/user/reset/account',
    name: '重置账号',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  },
  exportSelectedUser: {
    url: 'system/dept/export/check/user',
    name: '导出选中-部门下的员工',
    post: async function(data, config={responseType: 'blob'}) {
      return await http.post(this.url, data, config)
    }
  },
  exportAllUser: {
    url: 'system/dept/export/user',
    name: '导出全部-部门下的员工',
    post: async function(data, config={responseType: 'blob'}) {
      return await http.post(this.url, data, config)
    }
  },
  roleMenuSelected: { // 角色权限管理
    url: 'system/menu/roleMenuTreeSelect',
    name: '菜单权限',
    get: async function(params) {
      return await http.get(this.url, params)
    }
  },
  saveRoleMenu: { // 角色权限管理
    url: 'system/menu/update/roleMenu',
    name: '保存菜单或操作权限',
    post: async function(data) {
      return await http.post(this.url, data)
    }
  }
}